export default __webpack_public_path__ + "d79ea29e62106cab7be3559c554c95c1.png";